import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViewUHIDDetailsComponent } from '../../view-uhiddetails/view-uhiddetails.component';
import { CallCenterInboundCallRoutingModule } from './call-center-inbound-call-routing.module';
import { CallCenterInboundCallComponent } from '../call-center-inbound-call.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FileUploadModule } from 'primeng/fileupload';
import { ToastModule } from 'primeng/toast';
import { TableModule } from 'primeng/table';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { DropdownModule } from 'primeng/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PaginatorModule } from 'primeng/paginator';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { MultiSelectModule } from 'primeng/multiselect';
import { TabMenuModule } from 'primeng/tabmenu';
import { StepsModule } from 'primeng/steps';
import { PanelModule } from 'primeng/panel';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { CreateAppointmentDialogComponent } from '../../create-appointment-dialog/create-appointment-dialog.component';
import { AskApolloCreateHCAppointmentsComponent } from '../../ask-apollo-create-hcappointments/ask-apollo-create-hcappointments.component';
import { ITDoseURLComponent } from '../../it-dose-url/it-dose-url.component';
import { WalkingComponent } from '../../walking/walking.component';
import { CreateHealthcheckAppointmentComponent } from '../../create-healthcheck-appointment/create-healthcheck-appointment.component';
import { PackageEnquiryComponent } from '../../package-enquiry/package-enquiry.component';
import { GeneralEnquiryComponent } from '../../general-enquiry/general-enquiry.component';
import { RescheduleAppointmentComponent } from '../../reschedule-appointment/reschedule-appointment.component';
import { CancelAppointmentComponent } from '../../cancel-appointment/cancel-appointment.component';
import { CallAppointmentHistoryComponent } from '../../call-appointment-history/call-appointment-history.component';
import { AskApolloHCAppointmentsHistoryComponent } from '../../ask-apollo-hcappointments-history/ask-apollo-hcappointments-history.component';
import { AskApolloCorpAppointmentsHistoryComponent } from '../../ask-apollo-corp-appointments-history/ask-apollo-corp-appointments-history.component';
import { ItDoseAppointmentHistoryComponent } from '../../it-dose-appointment-history/it-dose-appointment-history.component';
import {CallCenterComponent} from '../../call-center/call-center.component'
import { CallBackLaterComponent } from '../../call-back-later/call-back-later.component';

import { CallDropComponentimplements } from '../../call-drop/call-drop.component';
import { IrreleventLeadComponent } from '../../irrelevent-lead/irrelevent-lead.component';
import { NotRespondingComponent } from '../../not-responding/not-responding.component';
import { NumberNotValidComponent } from '../../number-not-valid/number-not-valid.component';
import { AddUserComponent } from '../../add-user/add-user.component';
import { FeedbacksComponent } from '../../feedbacks/feedbacks.component';


@NgModule({
  declarations: [CallCenterComponent,CallCenterInboundCallComponent,CallAppointmentHistoryComponent,ViewUHIDDetailsComponent,AskApolloCorpAppointmentsHistoryComponent,ItDoseAppointmentHistoryComponent,AskApolloHCAppointmentsHistoryComponent, CreateAppointmentDialogComponent, GeneralEnquiryComponent,PackageEnquiryComponent, CreateHealthcheckAppointmentComponent, AskApolloCreateHCAppointmentsComponent,ITDoseURLComponent, WalkingComponent,RescheduleAppointmentComponent, CancelAppointmentComponent,
    CallBackLaterComponent,CallDropComponentimplements,IrreleventLeadComponent,NotRespondingComponent,NumberNotValidComponent,AddUserComponent,FeedbacksComponent],
  imports: [
    CommonModule,
    CallCenterInboundCallRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    DropdownModule,
    ModalModule.forRoot(),
    FileUploadModule,
    ToggleButtonModule,
    TableModule,
    ToastModule,
    PaginatorModule,
    DialogModule,
    MultiSelectModule,
    CalendarModule,
    TabMenuModule,
    StepsModule,
    PanelModule,
    ButtonModule,
    AutoCompleteModule,
    TypeaheadModule.forRoot(),
    BsDatepickerModule.forRoot(),
  ],
  exports: [
    CallCenterInboundCallComponent
  ]
})
export class CallCenterInboundCallModule { }
